import { useAuth } from "@/contexts/AuthContext";
import { ArrowUpRight, Clock, Lock } from "lucide-react";

export default function TrialBanner() {
  const { trial } = useAuth();
  if (!trial || trial.plan === "ACTIVE") return null;

  const isExpired = trial.trial_status === "EXPIRED" || trial.read_only;
  const daysLeft = trial.trial_end ? Math.max(0, Math.ceil((new Date(trial.trial_end) - new Date()) / (1000 * 60 * 60 * 24))) : 0;

  if (isExpired) {
    return (
      <div className="mx-4 md:mx-6 lg:mx-8 mt-4 p-3 rounded-xl border border-red-500/30 bg-red-500/5 flex items-center justify-between" data-testid="trial-expired-banner">
        <div className="flex items-center gap-2">
          <Lock className="w-4 h-4 text-red-400" />
          <div>
            <span className="text-sm text-red-400 font-semibold">Trial expired — read-only mode</span>
            <p className="text-[11px] text-slate-500">Your system is still protecting your financial structure. Upgrade to regain control and execution.</p>
          </div>
        </div>
        <button className="shrink-0 px-4 py-1.5 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 text-xs font-semibold flex items-center gap-1 hover:from-amber-400 hover:to-amber-500 transition-all" data-testid="upgrade-btn">
          Upgrade Now <ArrowUpRight className="w-3 h-3" />
        </button>
      </div>
    );
  }

  if (daysLeft <= 5) {
    return (
      <div className="mx-4 md:mx-6 lg:mx-8 mt-4 p-2.5 rounded-xl border border-amber-500/20 bg-amber-500/5 flex items-center justify-between" data-testid="trial-warning-banner">
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-amber-400" />
          <span className="text-xs text-amber-400">{daysLeft} days left on your trial. Upgrade to keep full access.</span>
        </div>
        <button className="shrink-0 px-3 py-1 rounded-full bg-amber-500/20 text-amber-400 text-[10px] font-semibold hover:bg-amber-500/30 transition-all">
          Upgrade <ArrowUpRight className="w-3 h-3 inline" />
        </button>
      </div>
    );
  }

  return (
    <div className="mx-4 md:mx-6 lg:mx-8 mt-4 p-2 rounded-lg border border-cyan-500/15 bg-cyan-500/5 flex items-center gap-2" data-testid="trial-active-banner">
      <Clock className="w-3 h-3 text-cyan-400" />
      <span className="text-[10px] text-cyan-400 font-mono">{daysLeft} days remaining on trial</span>
    </div>
  );
}
